<script>
import { mapGetters } from 'vuex'
import arraysAndJsonsHelpers from '@/libs/arraysAndJsonsHelpers'
export default {
  computed: {
    ...mapGetters(['appUuid', 'userKeybeExtraData'])
  },
  created () {
    this.setCurrentAppIndexInUserKeybeExtraData()
    this.getUserKeybeAppExtraData()
  },
  data () {
    return {
      currentAppIndexInUserKeybeExtraData: -1,
      userKeybeCurrentAppExtraData: {}
    }
  },
  methods: {
    findUserKeybeExtraData (field) {
      const index = this.userKeybeExtraData.findIndex(item => item.field === field)
      let foundExtraData = null
      if (index !== -1) {
        if (arraysAndJsonsHelpers.isJson(this.userKeybeExtraData[index].value)) {
          foundExtraData = JSON.parse(this.userKeybeExtraData[index].value)
        } else {
          foundExtraData = this.userKeybeExtraData[index].value
        }
      }
      return {
        index,
        foundExtraData
      }
    },
    getUserKeybeAppExtraData () {
      let currentAppExtraData = this.userKeybeExtraData[this.currentAppIndexInUserKeybeExtraData].value
      if (typeof currentAppExtraData === 'string' && arraysAndJsonsHelpers.isJson(currentAppExtraData)) {
        currentAppExtraData = JSON.parse(currentAppExtraData)
      }
      this.userKeybeCurrentAppExtraData = currentAppExtraData
    },
    getUserKeybeAppExtraDataItem (key) {
      return this.userKeybeCurrentAppExtraData[key]
    },
    initUserKeybeAppExtraDataItem (itemKey, defaultItemValue) {
      let foundItem = this.getUserKeybeAppExtraDataItem(itemKey)
      if (!foundItem) {
        foundItem = defaultItemValue
        this.updateUserKeybeAppExtraDataItems([
          { key: itemKey, value: defaultItemValue }
        ])
      }
      return foundItem
    },
    initUserKeybeAppExtraDataAllAndSelectedItems (allItemsKey, selectedItemsKey, defaultColumnsToSelect = [], allCurrentAppItems = [], allCurrentAppItemsMappingKey) {
      // Searching person all and selected extradata saved in userKeybeAppExtraData
      let allItems = this.getUserKeybeAppExtraDataItem(allItemsKey) || []
      let selectedItems = this.getUserKeybeAppExtraDataItem(selectedItemsKey) || []
      // Update people columns flag
      let updateUserKeybeAppExtraDataFlag = false

      // If not selectedItemsWereFound, set default selectedItems
      if ((!Array.isArray(selectedItems) || !selectedItems.length) && defaultColumnsToSelect.length) {
        updateUserKeybeAppExtraDataFlag = true
        allItems = [...allCurrentAppItems]
        selectedItems = [...defaultColumnsToSelect]
      }

      // Comparing allItems with allCurrentAppItems and resetting them if they are different
      let allCurrentAppItemsFields = allCurrentAppItems
      let allItemsFields = allItems
      // Mapping the arrays if a valid allCurrentAppItemsMappingKey was passed as parameter
      if (allCurrentAppItemsMappingKey) {
        allCurrentAppItemsFields = allCurrentAppItems.map(item => item[allCurrentAppItemsMappingKey])
        allItemsFields = allItems.map(item => item[allCurrentAppItemsMappingKey])
      }
      if (!arraysAndJsonsHelpers.areArraysEqual(allCurrentAppItemsFields, allItemsFields)) {
        allItems = [...allCurrentAppItems]
        selectedItems = [...defaultColumnsToSelect]
        updateUserKeybeAppExtraDataFlag = true
      }

      // Update userKeybeAppExtraData if updateUserKeybeAppExtraDataFlag === true
      if (updateUserKeybeAppExtraDataFlag) {
        this.updateUserKeybeAppExtraDataItems([
          { key: allItemsKey, value: allItems },
          { key: selectedItemsKey, value: selectedItems }
        ])
      }
      // Returning the real values at the end of the function
      return { allItems, selectedItems }
    },
    setCurrentAppIndexInUserKeybeExtraData () {
      this.currentAppIndexInUserKeybeExtraData = this.userKeybeExtraData
        .map(item => item.field)
        .indexOf(`APP_${this.appUuid.toUpperCase()}`)
    },
    async updateUserKeybeAppExtraDataItems (items) {
      for (const item of items) {
        const { key, value } = item
        this.userKeybeCurrentAppExtraData[key] = value
      }
      await this.updateUserKeybeExtraData(
        this.currentAppIndexInUserKeybeExtraData,
        this.userKeybeCurrentAppExtraData
      )
    },
    async updateUserKeybeExtraData (extraDataIndex, value, field = '') {
      if (extraDataIndex === -1 && !field) return console.error('You must enter a field if the index === -1')

      const extraData = [...this.userKeybeExtraData]
      if (extraDataIndex !== -1) {
        extraData[extraDataIndex].value = value
      } else if (field && typeof field === 'string' && field.trim()) {
        extraData.push({
          field, value, access: 'app'
        })
      }
      await this.$store.dispatch('updateAdminUserInfo', {
        extraData
      })
    }
  }
}
</script>
